<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费项名称：</span>
        </div>
        <el-select v-model="paymentItemCodes"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod1"
                   placeholder="请选择收费项名称"
                   >
          <el-option v-for="item in paymentItemList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费模式：</span>
        </div>
        <el-input v-model="formData.chargeMode" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费类型：</span>
        </div>
        <el-input v-model="formData.chargeType" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费主体：</span>
        </div>
        <el-select v-model="personCodes"
                   v-if="formData.chargeType==='个人'"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod2"
                   placeholder="请选择缴费主体">
          <el-option v-for="item in personList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>

        <el-select v-model="enterpriseCodes"
                   v-else
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod3"
                   placeholder="请选择缴费主体">
          <el-option v-for="item in enterpriseList" :key="item.code"
                     :label="item.enterpriseName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">所属住户：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" disabled/>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费金额：</span>
        </div>
        <el-input v-model="formData.chargeAmount" size="small" style="width: 280px"/>
      </div>

      <div class="form-line" v-if="formData.chargeMode==='经办人代收'">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款方式：</span>
        </div>
        <el-select v-model="formData.payMethod" placeholder="请选择" size="small" style="width: 280px">
          <el-option v-for="item in payChannelModifyList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">房间号：</span>
        </div>
        <el-input v-model="formData.roomNumber" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/CustomPayment";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";

export default {
  components: {
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "charge-management-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "收费管理"
        }
      ],
      mainTitle: "添加收费",
      subheading: "",
      payChannelModifyList: [
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "支付宝"
        },
        {
          key: "3",
          label: "银行转账"
        },
        {
          key: "4",
          label: "现金"
        },
        {
          key: "5",
          label: "其他"
        }
      ],
      payStatusModifyList: [
        {
          key: "0",
          label: "未缴费"
        },
        {
          key: "2",
          label: "完全支付"
        }
      ],
      invoiceStatusModifyList: [
        {
          key: "0",
          label: "未开票"
        },
        {
          key: "1",
          label: "已开票"
        }
      ],
      formData: {},
      paymentItemCodes: "",
      paymentItemList: [],
      personCodes: "",
      personList: [],
      enterpriseCodes: "",
      enterpriseList: []
    };
  },
  created() {
    this.currentCode = this.$route.params.id;
    // this.getPaymentItemList();
    this.remoteMethod1();
    this.remoteMethod2();
    this.remoteMethod3();
  },
  methods: {
    remoteMethod1(query) {
      this.getPaymentItemList(query);
    },
    remoteMethod2(query) {
      this.getPersonList(query);
    },
    remoteMethod3(query) {
      this.getEnterpriseList(query);
    },
    //获取收费项列表
    getPaymentItemList(searchKey) {
      this.$axios
        .post(api.getPaymentItemList, { searchKey: searchKey || "" })
        .then(res => {
          this.paymentItemList = res.data.data;
        })
        .catch(errorHandler("获取收费项管理列表失败"));
    },

    //获取个人列表
    getPersonList(searchKey) {
      this.$axios
        .post(api.getPersonList, { searchKey: searchKey || "" })
        .then(res => {
          this.personList = res.data.data;
        })
        .catch(errorHandler("获取个人列表失败"));
    },

    //获取租户列表
    getEnterpriseList(searchKey) {
      this.$axios
        .post(api.getEnterpriseList, { searchKey: searchKey || "" })
        .then(res => {
          this.enterpriseList = res.data.data;
        })
        .catch(errorHandler("获取租户列表失败"));
    },

    toManagement() {
      this.$router.push({
        name: "charge-management"
      });
    },

    confirm() {
      if (!this.formData.paymentItemCode) {
        nError("请选择收费项名称");
        return false;
      }
      if (!this.formData.chargeAmount) {
        nError("请输入收费金额");
        return false;
      }
      if (
        !this.formData.payMethod &&
        this.formData.chargeMode === "经办人代收"
      ) {
        nError("请选择收款方式");
        return false;
      }
      if (this.formData.chargeAmount < 0) {
        nError("输入的收费金额不能小于0");
        return false;
      }
      if (!this.formData.personCode && !this.formData.enterpriseCode) {
        nError("请选择缴费主体");
        return false;
      }
      this.$axios
        .post(api.addChargeBill, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.toManagement();
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.toManagement();
    }
  },
  watch: {
    paymentItemCodes(val) {
      this.paymentItemList.map(v => {
        if (v.code === val) {
          console.log(v);
          this.formData.paymentItemCode = v.code;
          this.formData.paymentItemName = v.name;
          this.formData.chargeMode = v.chargeMode;
          this.formData.chargeType = v.chargeType;
          this.formData.type = v.type;
          this.getPaymentItemList();
        }
      });
    },
    personCodes(val) {
      this.personList.map(v => {
        if (v.code === val) {
          console.log(v);
          this.formData.personCode = v.code;
          this.formData.payer = v.name;
          this.formData.phone = v.phone;
          this.formData.roomNumber = v.roomInfoName;
          this.formData.enterpriseName = v.enterpriseName;
          this.formData.enterpriseCode = v.enterpriseCode;
          this.getPersonList();
        }
      });
    },
    enterpriseCodes(val) {
      this.enterpriseList.map(v => {
        if (v.code === val) {
          console.log(v);
          this.formData.payer = v.enterpriseName;
          this.formData.enterpriseName = v.enterpriseName;
          this.formData.phone = v.phone;
          this.formData.roomNumber = v.roomInfoNumber;
          this.formData.enterpriseCode = v.code;
          this.getEnterpriseList();
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 140px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/ChargeManagement/ChargeManagementAdd.vue